'use client';

import { useContext } from 'react';
import { CommandPaletteContext } from './command-palette-context';
import type { ICommandPaletteContextValue } from './use-command-palette-context-types';

export function useCommandPaletteContext(): ICommandPaletteContextValue {
  const value = useContext(CommandPaletteContext);
  if (!value) {
    throw new Error('useCommandPaletteContext must be used within CommandPaletteProvider');
  }
  return value;
}
